import React, { useState, ReactNode, ReactNodeArray } from 'react'
import { getIn, FieldProps } from 'formik'
import { CustomTextFieldOrigin } from '../CustomTextFieldOrigin'
import { InputAdornment } from '@material-ui/core'

export interface ICustomTextFieldProps {
  value?: string
  helperText?: string
  endAdornment?: ReactNode | ReactNodeArray
  validateImmediately?: boolean
  min?: number
  max?: number
  disabled?: boolean
  error?: boolean
  trimValueOnBlur?: boolean
  changeValue?(value: string): string
}

export const CustomTextField = ({
  field,
  form: { touched, errors },
  helperText,
  validateImmediately,
  changeValue,
  min,
  max,
  trimValueOnBlur,
  ...props
}: FieldProps<any> & ICustomTextFieldProps) => {
  // Validation triggers only for touched fields
  // https://github.com/jaredpalmer/formik/issues/699
  const [changed, setChanged] = useState(false)
  const isNotValid =
    (changed || validateImmediately || getIn(touched, field.name)) &&
    !!getIn(errors, field.name)
  return (
    <CustomTextFieldOrigin
      {...field}
      {...props}
      id={field.name}
      error={isNotValid}
      helperText={isNotValid ? getIn(errors, field.name) : helperText}
      onBlur={(e) => {
        if (trimValueOnBlur) {
          e.target.value = e.target.value.trim()
          field.onChange(e)
        }
        field.onBlur(e)
      }}
      onChange={(e) => {
        setChanged(true)
        if (changeValue) {
          e.target.value = changeValue(e.target.value)
        }
        field.onChange(e)
      }}
      endAdornment={
        props.endAdornment && (
          <InputAdornment position="end">{props.endAdornment}</InputAdornment>
        )
      }
      value={field.value === null ? '' : props.value || field.value}
      disabled={props.disabled}
    />
  )
}
